import React from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';
import NoData from '@gp/components/NoData';
import CardSlot from '@gp/components/CardSlot';

import type { IBaseProps } from '@home/types/common';

interface IMilestoneNoDataProps extends IBaseProps {
  editable?: boolean;
  onAddMilestone?: () => void;
}

const MilestoneNoData: React.FC<IMilestoneNoDataProps> = (props) => {
  const { style, className, editable, onAddMilestone } = props;

  return (
    <CardSlot style={style} className={classnames('', className)}>
      <NoData
        text={
          <>
            <div>This project has no milestone information yet.</div>
            {editable && (
              <div>
                Please click to{' '}
                <Button
                  type="link"
                  onClick={(e) => {
                    e?.stopPropagation();
                    onAddMilestone?.();
                  }}
                >
                  Add new Milestone
                </Button>
              </div>
            )}
          </>
        }
        height={200}
      />
    </CardSlot>
  );
};

export default MilestoneNoData;
